<!-- <p>subject-cant-unlock-dialog works!</p> -->


<!-- Cant unlock popup -->
<div class="subcription-pop-wrap">
    <a class="link LRN-crossbtn-cont" mat-dialog-close><img src="assets/img/filter-close-icon.png" class="icon LRN-crossbtn-img" /></a>
    <div class="pophdr-area">        
        <h3 class="LRN_trialheading">Your trial has expired!</h3>
            <img src="assets/img/time-trial-calculator.svg" alt="" class="LRN-extire-timeimg" />
    </div>
    
    <h4 class="LRN-trialblueheading">A little something, just for you!  </h4>
    <h5 class="LRN-textoff"><span>FLAT 10% OFF</span> on upgrading to
        Pro Plus Package
        </h5>
    <div class="LRN-coupenboxcont">
        <img src="assets/img/cuponcode-icon.svg" alt="" class="LRN-gifticonimg" />
        <div class="LRN-coupen-innertext">Coupon code: {{couponCode}}</div>
         <button class="LRN-copybutton" (click)="copyCoupon(couponCode)"><img src="assets/img/Copy-icon.svg" alt="" class="LRN-copyicon" />
            <span class="LRN-tooltip" *ngIf="showCoupon">Copied</span>
        </button> 
    </div>
    <div class="popactn-area">
        <button class="LRN-btn-explr" (click)="buyProPlus()">Upgrade to Pro Plus Package</button>        
    </div>
</div>


